import { r as registerInstance, c as createEvent, h, g as getElement } from './index-d4808923.js';
import { b as bem } from './index.esm-7182addc.js';

const gravityOptionListFilterCss = ":host{display:contents}.gravity-option-list-filter{height:100%}.gravity-option-list-filter__list{display:block;height:100%}.gravity-option-list-filter__list:focus{outline:unset}";
const GravityOptionListFilterStyle0 = gravityOptionListFilterCss;

const GravityOptionListFilter = class {
    constructor(hostRef) {
        registerInstance(this, hostRef);
        this.filterChange = createEvent(this, "filterChange", 3);
        this.generateClassNames = bem('gravity-option-list-filter');
        this.handleSearchChange = (event) => {
            var _a, _b;
            (_b = (_a = this.filterConfig).onSearchChange) === null || _b === void 0 ? void 0 : _b.call(_a, this.filterConfig.id, event.detail);
        };
        this.handleDropdownOptionSelected = (event) => {
            this.filterChange.emit({ filterId: this.filterConfig.id, value: event.detail });
        };
        this.filterConfig = undefined;
    }
    handleFilterConfigChange(newConfig, oldConfig) {
        var _a, _b;
        if (this.hasValueChanged(newConfig.value, oldConfig.value)) {
            (_b = (_a = this.filterConfig).onFilterChange) === null || _b === void 0 ? void 0 : _b.call(_a, newConfig.id, newConfig.value);
        }
    }
    hasValueChanged(newValue = [], oldValue = []) {
        if (newValue.length !== oldValue.length)
            return true;
        const sortedNewValue = newValue.slice().sort();
        const sortedOldValue = oldValue.slice().sort();
        return !sortedNewValue.every((value, index) => value === sortedOldValue[index]);
    }
    render() {
        return (h("div", { key: '51efacfe252ad83bd72954baab84ae4ee9d11e6f', class: this.generateClassNames() }, h("gravity-dropdown-inner", { key: '612e7dc61ab307ad2d8e9b9f228e20cc62fbf974', class: this.generateClassNames('list'), dropdown: this.element, keyboardNavigation: true, maxHeight: 980, onDropdownOptionSelected: this.handleDropdownOptionSelected, onSearchChange: this.handleSearchChange, options: this.filterConfig.options, queryType: this.filterConfig.searchable && (this.filterConfig.queryType || 'filter'), searchBusy: this.filterConfig.searchBusy, searchPlaceholder: this.filterConfig.searchPlaceholder, selected: this.filterConfig.value, selectionBehavior: "multi", tabindex: this.filterConfig.searchable ? undefined : '0', width: "fixed" })));
    }
    get element() { return getElement(this); }
    static get watchers() { return {
        "filterConfig": ["handleFilterConfigChange"]
    }; }
};
GravityOptionListFilter.style = GravityOptionListFilterStyle0;

export { GravityOptionListFilter as gravity_option_list_filter };

//# sourceMappingURL=gravity-option-list-filter.entry.js.map